export default __webpack_public_path__ + "21a52f9fbd86fe212784b099bc5101e7.png";